module.exports = __webpack_public_path__ + "static/media/nonpubliclogo.6c62197b.png";